export default __webpack_public_path__ + "static/media/Strugani 20.09d5a652.jpg";